import { render, staticRenderFns } from "./Nanxin.vue?vue&type=template&id=20b3480a&scoped=true&"
import script from "./Nanxin.vue?vue&type=script&lang=js&"
export * from "./Nanxin.vue?vue&type=script&lang=js&"
import style0 from "./Nanxin.vue?vue&type=style&index=0&id=20b3480a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b3480a",
  null
  
)

export default component.exports